import { useCallback, useState } from 'react'

export interface ContextMenuState<T> {
  x: number
  y: number
  data: T
}

export function useContextMenu<T>() {
  const [menu, setMenu] = useState<ContextMenuState<T> | null>(null)

  const openContextMenu = useCallback((x: number, y: number, data: T) => {
    setMenu({ x, y, data })
  }, [])

  const closeContextMenu = useCallback(() => {
    setMenu(null)
  }, [])

  return {
    menu,
    isOpen: menu !== null,
    openContextMenu,
    closeContextMenu,
  }
}
